export default Object.freeze({
  presetName: {
    title: 'Preset name',
    message: 'Mandatory field where you specify a name for the preset',
  },
  description: {
    title: 'Description',
    message: 'Description of the preset',
  },
  category: {
    title: 'Category',
    message: 'Category of the preset',
  },
  container: {
    title: 'Container',
    message: 'Container for the preset',
  },
  recordtype: {
    title: 'Record Type',
    message: '<b>Record All</b> option allows Live Encoder to record all stream and saves the record as one file. <br><br> <b>Record hourly</b> option allows Live Encoder to record stream hourly and saves the record as unique files',
  },
})
